<template>
    <div class="card">
        <div class="card-header bg-white">
            <h5 class="me-auto">{{ title }}</h5>
        </div>
        <div class="card-body p-0">
            <template>
                <v-data-table class="elevation-1 table-sm" 
                    :headers="headers.filter( (e, i) => { if(is_open){ return e }else{ if(i > 0){ return e } } })"
                    :items="data"
                    hide-default-footer
                    dense
                    :items-per-page="-1">
                    <template v-slot:[`item.remove`]="{ item, index }" v-if="is_open">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <a @click="REMOVE(item, index)" v-if="item.state_id == 3 || item.state_id == 2"
                                    v-bind="attrs"
                                    v-on="on"
                                    class="text-gv-danger mx-1">
                                    <i class="bi bi-x-circle-fill"></i>
                                </a>
                                <span v-else
                                    class="text-muted mx-1 disabled">
                                    <i class="bi bi-x-circle-fill"></i>
                                </span>
                            </template>
                            <small>Quitar</small>
                        </v-tooltip>
                    </template>
                    <template v-slot:[`item.id`]="{ item }">
                        <router-link v-if="globalViewOption('PackageDetail')"
                            :to="{ name: 'PackageDetail', params: { id: item.id } }"
                            class="text-decoration-none">
                            {{ item.type }}{{ item.id }}
                        </router-link>
                        <div v-else>
                            {{ item.type }}{{ item.id }}
                        </div>
                    </template>
                    <template v-slot:[`item.pieces`]="{ item }">
                        {{ Number(item.pieces || 0).toFixed(2) }}
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                        <v-tooltip bottom class="mx-1">
                            <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on" class="nowrap" v-if="Array.isArray(item.description)">
                                    {{ item.description[0] }} ...
                                </div>
                            </template>
                            <small><div v-for="(description, key) in  item.description" :key="key">{{ description }}</div></small>
                        </v-tooltip>
                    </template>
                    <template v-slot:[`item.lengthy`]="{ item }">
                        {{ Number(item.lengthy || 0).toFixed(2) }}
                    </template>
                    <template v-slot:[`item.width`]="{ item }">
                        {{ Number(item.width || 0).toFixed(2) }}
                    </template>
                    <template v-slot:[`item.tall`]="{ item }">
                        {{ Number(item.tall || 0).toFixed(2) }}
                    </template>
                    <template v-slot:[`item.weight`]="{ item }">
                        {{ Number(item.weight || 0).toFixed(2) }}
                    </template>
                    <template v-slot:[`item.volumetric_weight`]="{ item }">
                        {{ Number(item.volumetric_weight || 0).toFixed(2) }}
                    </template>
                    <template v-slot:[`item.files`]="{ item }">
                        <div class="d-flex">
                            <span class="badge badge-light badge-pill mr-1" v-for="(file, index) in item.files">
                                <button @click="onPath(file.id)" class="text-decoration-none">{{ index + 1 }}</button>
                            </span>
                        </div>
                    </template>
                    <template slot="body.append">
                        <tr style="color: rgba(0,0,0,.6);">
                            <th v-if="is_open">Quitar</th>
                            <th>Transportista</th>
                            <th>WH #</th>
                            <th>Consignatario</th>
                            <th>Identificación</th>
                            <th>Piezas</th>
                            <th>Embalaje</th>
                            <th>Descripción</th>
                            <th>L</th>
                            <th>W</th>
                            <th>H</th>
                            <th>Peso</th>
                            <th>Vol</th>
                            <th>Transportista</th>
                            <th>No. Tracking</th>
                            <th></th>
                        </tr>
                        <tr>
                            <td class="text-start" v-if="is_open"></td>
                            <td class="text-start"></td>
                            <td class="text-start"></td>
                            <td class="text-start"></td>
                            <th class="text-right" style="color: rgba(0,0,0,.6);"><b>Total:</b></th>
                            <td class="text-start"><span>{{ Number((data).reduce((accumulator, object) => { return accumulator + parseFloat(object.pieces) }, 0) || 0).toFixed(2) }}</span></td>
                            <td class="text-start"></td>
                            <td class="text-start"></td>
                            <td class="text-start"><span>{{ Number((data).reduce((accumulator, object) => { return accumulator + parseFloat(object.lengthy) }, 0) || 0).toFixed(2) }}</span></td>
                            <td class="text-start"><span>{{ Number((data).reduce((accumulator, object) => { return accumulator + parseFloat(object.width) }, 0) || 0).toFixed(2) }}</span></td>
                            <td class="text-start"><span>{{ Number((data).reduce((accumulator, object) => { return accumulator + parseFloat(object.tall) }, 0) || 0).toFixed(2) }}</span></td>
                            <td class="text-start"><span>{{ Number((data).reduce((accumulator, object) => { return accumulator + parseFloat(object.weight) }, 0) || 0).toFixed(2) }}</span></td>
                            <td class="text-start"><span>{{ Number((data).reduce((accumulator, object) => { return accumulator + parseFloat(object.volumetric_weight) }, 0) || 0).toFixed(2) }}</span></td>
                            <td class="text-start"></td>
                            <td class="text-start"></td>
                            <td class="text-start"></td>
                        </tr>
                    </template>
                </v-data-table>
            </template>
        </div>
    </div>
</template>
<script>
export default{
    props: ['data', 'is_open', 'title'],
    data(){
        return{
            headers: [
                { text: 'Quitar', value: 'remove', sortable: false },
                { text: 'WH #', value: 'id', sortable: false },
                { text: 'Remitente', value: 'shipper', sortable: false },
                { text: 'Consignatario', value: 'user.name', sortable: false },
                { text: 'Identificación', value: 'user.identification', sortable: false },
                { text: 'Piezas', value: 'pieces', sortable: false },
                { text: 'Embalaje', value: 'packing.name', sortable: false },
                { text: 'Descripción', value: 'description', sortable: false },
                { text: 'La.', value: 'lengthy', sortable: false },
                { text: 'An.', value: 'width', sortable: false },
                { text: 'Al.', value: 'tall', sortable: false },
                { text: 'Peso', value: 'weight', sortable: false },
                { text: 'Vol.', value: 'volumetric_weight', sortable: false },
                { text: 'Transportador', value: 'carrier.name', sortable: false },
                { text: 'No. Tracking', value: 'tracking', sortable: false },
                { text: 'Adjuntos', value: 'files', sortable: false },
            ],
            count: 0,
        }
    },
    methods: {
        REMOVE: function(item, index){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                axios({url: '/remove/packages/awbs', method: 'POST', data: { id: item.id } })
                .then((resp) => {
                    vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    vue.data.splice(index, 1)
                })
                .catch((err) => {
                    if(err.response.status !== 422){
                        let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.errors = err.response.data
                    }
                })
                .finally((resp)=>{
                    vue.count = 0
                })
            }
        },
        onPath: function(id){
            axios({url: '/temporal/path/'+ id, method: 'GET' })
            .then((resp) => {
                var anchor = document.createElement('a')
                anchor.href = resp.data
                anchor.target = "_blank"
                anchor.click()
            })
        }
    }
}
</script>